import React from "react";
import { Link } from "react-router-dom";
import { Calendar, ChevronRight } from "lucide-react";
import { DD_MM_YYYY, timeFormat } from "src/helpers";
import { ISOString } from "src/types";

interface CheckInHistoryListProps {
  buildLink?: (timestamp: ISOString) => string;
  checkInTimestamps?: ISOString[];
}

export const CheckInHistoryList: React.FC<CheckInHistoryListProps> = ({ buildLink, checkInTimestamps }) => {
  if (!checkInTimestamps || checkInTimestamps.length === 0) {
    return null;
  }

  return (
    <div className="bg-white border border-secondary-200 rounded-lg p-4">
      <div className="flex items-center space-x-2 mb-4">
        <Calendar className="w-4 h-4 text-primary-600" />
        <h4 className="text-sm font-semibold text-secondary-800">Check-In History</h4>
        <span className="ml-auto text-xs text-secondary-500 font-medium">
          {checkInTimestamps.length} {checkInTimestamps.length === 1 ? "entry" : "entries"}
        </span>
      </div>
      <div className="divide-y divide-secondary-100">
        {checkInTimestamps.map((checkInTimestamp, index) => {
          const date = new Date(checkInTimestamp);
          const formattedDate = DD_MM_YYYY.formatDate(date);
          const formattedTime = timeFormat(date);

          if (buildLink) {
            return (
              <Link
                key={index}
                to={buildLink(checkInTimestamp)}
                className="group flex items-center justify-start py-3 px-2 -mx-2 rounded-lg transition-all duration-200 hover:bg-primary-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 w-fit"
              >
                <div className="flex items-center gap-3 w-fit">
                  <div className="flex-shrink-0 w-2 h-2 rounded-full bg-primary-500 group-hover:bg-primary-600 transition-colors" />
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-secondary-900">{formattedDate}</span>
                    <span className="text-xs text-secondary-500">•</span>
                    <span className="text-sm text-secondary-600">{formattedTime}</span>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-secondary-400 group-hover:text-primary-600 transition-colors" />
              </Link>
            );
          }

          return (
            <div key={index} className="flex items-center gap-3 py-3 px-2 -mx-2 rounded-lg">
              <div className="flex-shrink-0 w-2 h-2 rounded-full bg-secondary-300" />
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-medium text-secondary-900">{formattedDate}</span>
                <span className="text-xs text-secondary-500">•</span>
                <span className="text-sm text-secondary-600">{formattedTime}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
